module.exports = __webpack_public_path__ + "img/50ne.f77d708e.svg";